/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ChatBigIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 16 15", fill: "currentColor", width: size || '16', height: size || '15', ...props },
    React.createElement("path", { fill: "currentColor", d: "M16 12v2.199a.7.7 0 0 1-1.244.44L12.619 12H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10zM4 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4zm7 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1z", fillRule: "evenodd" })));
ChatBigIcon.displayName = 'ChatBigIcon';
export default ChatBigIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatBigIcon.js.map